import router from '../router'
import store from '../store'
import injector from 'vue-inject'

class Status{
    /**
     * Status 0
     */
    status0 () {
        // No additional action needed
    }

    /**
     * Error 401 - redirect to login
     * @param next
     * @returns {void|*}
     */
    status401 (next) {
        store.commit('logoutUser')
        return next ? next({ name: 'Login' }) : router.push({ name: 'Login' })
    }

    /**
     * Error 403
     */
    status403 () {
        return router.push({ name: 'TermsUpdate' });
    }

    /**
     * Error 404 - redirect to 404 page
     * @param next
     * @returns {void|*}
     */
    status404 () {
        store.commit('setError', {
            status: true,
            code: 404,
            redirect: false
        })
    }

    /**
     * Error 500 - redirect to 500 page
     * @param next
     * @returns {void|*}
     */
    status500 () {
        store.commit('setError', {
            status: true,
            code: 500,
            redirect: false
        })
    }
}

injector.service('status', Status)



// WEBPACK FOOTER //
// ./src/services/status.js